var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"configuration-local-assays-sections-modal-operations-form"},[_c('configuration-ontologies',{attrs:{"ontologies":_vm.state.ontologies},on:{"create":_vm.createOperation,"delete":_vm.deleteOperation}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }